import React from "react";
import {Card, Input, Checkbox, Button, Typography,} from "@material-tailwind/react";
import {KeyIcon} from "@heroicons/react/24/outline";
import GoogleIcon from '@mui/icons-material/Google';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';

const LoginPage=()=>{
   return(
    <>
     
        <div className='flex justify-center '>
             
    <Card color="transparent" shadow={false}>
     
      <h2 className='text-[#001ad2] font-bold md:text-3xl text-2xl md:text-left text-center'> Log in </h2>
      <h1 className='lg:text-sm text-xs mt-3'>
        Login to continue..
      </h1>
      <form className="mt-2 mb-2 w-80 max-w-screen-lg sm:w-96">
        <div className="mb-1 flex flex-col gap-4">
          <Input size="lg" label="User Name" required />
          <Input type="password" size="lg" label="Password" required/>
        </div>
        <a href="/" className="font-medium block mt-3 mb-3 text-blue-900 hover:text-blue-500">
                  Forgot your Password
        </a>
       
        <Button type='submit' className="flex items-center justify-center gap-3 w-full mt-1 bg-[#001ad2]">
          <KeyIcon strokeWidth={2} className="h-5 w-5" /> Log in
      </Button>

      <div className='flex justify-center mt-5 text-gray-500 text-sm'>
      ------------ or continue with: ------------
      </div>
      <div className='flex justify-center gap-4 pt-3'>
        <Button size="sm" className='bg-red-500 rounded-full h-12 w-12 p-0'> <GoogleIcon className='text-white-500' style={{ fontSize:'20px' }}/> </Button>
        <Button size="sm" className='bg-blue-800 h-12 w-12 rounded-full p-0'><FacebookOutlinedIcon className='text-white-500' style={{ fontSize:'25px' }}/>  </Button>
        <Button size="sm" className='bg-blue-400  h-12 w-12  rounded-full p-0'> <TwitterIcon className='text-white-500' style={{ fontSize:'20px' }}/> </Button>
      </div>
      

      </form>
    </Card>
 
        </div>
    </>
   )
};

export default LoginPage;